import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProperties = (params = {}) =>
  api.get("/properties", { params }).then((r) => r.data);

export const fetchProperty = (id) =>
  api.get(`/properties/${id}`).then((r) => r.data);

export const fetchCities = () => api.get("/cities").then((r) => r.data);

export const createEnquiry = (payload) =>
  api.post("/enquiries", payload).then((r) => r.data);

export const createAppointment = (payload) =>
  api.post("/appointments", payload).then((r) => r.data);

// ---- Admin ----
const adminHeaders = (creds) => ({
  "X-Admin-Email": creds?.email || "",
  "X-Admin-Password": creds?.password || "",
});

export const adminVerify = (creds) =>
  api.post("/admin/verify", null, { headers: adminHeaders(creds) }).then((r) => r.data);

export const adminListProperties = () =>
  api.get("/properties?limit=200").then((r) => r.data);

export const adminCreateProperty = (creds, payload) =>
  api.post("/admin/properties", payload, { headers: adminHeaders(creds) }).then((r) => r.data);

export const adminUpdateProperty = (creds, id, payload) =>
  api.put(`/admin/properties/${id}`, payload, { headers: adminHeaders(creds) }).then((r) => r.data);

export const adminDeleteProperty = (creds, id) =>
  api.delete(`/admin/properties/${id}`, { headers: adminHeaders(creds) }).then((r) => r.data);

export const adminListEnquiries = (creds) =>
  api.get("/admin/enquiries", { headers: adminHeaders(creds) }).then((r) => r.data);

export const adminListAppointments = (creds) =>
  api.get("/admin/appointments", { headers: adminHeaders(creds) }).then((r) => r.data);

export const adminUploadImage = (creds, file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload", fd, {
    headers: {
      ...adminHeaders(creds),
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) onProgress(Math.round((evt.loaded / evt.total) * 100));
    },
  }).then((r) => {
    const url = r.data.url.startsWith("http") ? r.data.url : `${BACKEND_URL}${r.data.url}`;
    return { ...r.data, url };
  });
};

export const formatZAR = (amount) =>
  new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: "ZAR",
    maximumFractionDigits: 0,
  }).format(amount);
